import { render, staticRenderFns } from "./HeadingDivider.vue?vue&type=template&id=7676a1aa&scoped=true&"
import script from "./HeadingDivider.vue?vue&type=script&lang=ts&"
export * from "./HeadingDivider.vue?vue&type=script&lang=ts&"
import style0 from "./HeadingDivider.vue?vue&type=style&index=0&id=7676a1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7676a1aa",
  null
  
)

export default component.exports